<template>

  <div class="ue-expenses-edit">
    <el-card>
      <div class="header">
        <h2>123-2.1.2.2.4.1.1 огпо работд  (Год: {{ dto.trancheYear }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="isLoading" v-if="dto.status !== 'APPROVED' && hasEditPermission()">Сохранить</el-button>
        </div>
      </div>

      <form >

        <div class="col-md-12" v-if="getNotAddedCategories().length > 0">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="lastname" class="form-label col-md-5">
                В таблицу добавить категория должностей
              </label>
              <div class="col-md-7">
                <select v-model="selectedCategory" id="category"
                        class="form-select">
                  <option v-for="category in getNotAddedCategories()" :key="category" :value="category">
                    {{ categories[category] }}
                  </option>
                </select>

              </div>

              <div class="col-md-2">
                <b-button variant="success" class="btn-sm" style="margin-left: 20px; margin-top: 2px;"
                          :disabled="!selectedCategory"
                          @click="addSelectedCategoryInfo()">
                  Добавить
                </b-button>
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">

          <table class="grid-table">
            <thead>
            <tr>
              <th class="title-cell">Категория должностей</th>
              <th>Фактическое кол-во работников (единиц)</th>
              <th>Класс профессионального риска*</th>
              <th>Страховой тариф (%)</th>
              <th>Годовой фонд оплаты труда</th>
              <th>Годовой ФОТ для расчета страховой премии</th>
              <th>Расчетная страховая сумма</th>
              <th>Фактическая страховая сумма</th>
              <th></th>
            </tr>
            </thead>
            <tbody>

            <!-- ВСЕГО row -->
            <tr class="total-row calculated-row readonly-text">
              <td>ВСЕГО</td>
              <td>{{ dto.employeeCount }}</td>
              <td></td>
              <td></td>
              <td>{{ formatNum(dto.annualSalary) }}</td>
              <td>{{ formatNum(dto.annualSalaryInsurance) }}</td>
              <td>{{ formatNum(dto.calculatedInsuranceSum) }}</td>
              <td>{{ formatNum(dto.actualInsuranceSum) }}</td>
              <td></td>
            </tr>

            <!-- ВСЕГО month rows -->
            <tr v-for="month in dto.months" :key="'total-m-'+month.month">
              <td>{{ monthNames[month.month - 1] }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td class="readonly-text">{{ formatNum(month.annualSalary) }}</td>
              <td></td>
              <td class="readonly-text">{{ formatNum(month.calculatedInsuranceSum) }}</td>
              <td></td>
              <td></td>
            </tr>

            <!-- Category sections -->
            <template v-for="category in dto.categories" :key="category.uuid || category.type">
              <!-- Category summary row -->
              <tr class="total-row calculated-row">
                <td>{{ categories[category.type] }}</td>
                <td class="readonly-text">{{ category.employeeCount }}</td>
                <td class="expense-sum-edit">
                  <el-select v-model="category.professionalRiskClass" placeholder="" size="small"
                             @change="onRiskClassChange(category)" style="width: 80px;">
                    <el-option v-for="rc in 22" :key="rc" :label="rc" :value="rc" />
                  </el-select>
                </td>
                <td class="readonly-text">{{ category.insuranceRatePercent }}</td>
                <td class="readonly-text">{{ formatNum(category.annualSalary) }}</td>
                <td class="expense-sum-edit">
                  <el-input v-model="category.annualSalaryInsurance" type="number" @input="recalculateAll()"/>
                </td>
                <td class="readonly-text">{{ formatNum(category.calculatedInsuranceSum) }}</td>
                <td class="readonly-text">{{ formatNum(category.actualInsuranceSum) }}</td>
                <td>
                  <el-button type="text" class="btn-icon color-red"
                             @click="onClickRemove(category)">
                    <font-awesome-icon :icon="['fas', 'cancel']"/>
                  </el-button>
                </td>
              </tr>

              <!-- Month rows under category -->
              <tr v-for="month in category.months" :key="month.uuid || (category.type + '-' + month.month)">
                <td>{{ monthNames[month.month - 1] }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td class="readonly-text">{{ formatNum(month.annualSalary) }}</td>
                <td></td>
                <td class="readonly-text">{{ formatNum(month.calculatedInsuranceSum) }}</td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.actualInsuranceSum" type="number" @input="recalculateAll()"/>
                </td>
                <td></td>
              </tr>
            </template>

            </tbody>

          </table>
        </div>


      </form>
      </el-card>
  </div>


  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import authService from "@/services/authService";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";
import expensesSalaryBonusService from "@/services/expensesSalaryBonusService";

const RISK_CLASS_TARIFF = {
  1: 0.12, 2: 0.29, 3: 0.48, 4: 0.49, 5: 0.52, 6: 0.53, 7: 0.54, 8: 0.65,
  9: 0.56, 10: 0.88, 11: 0.75, 12: 0.76, 13: 1.29, 14: 1.55, 15: 1.13,
  16: 1.17, 17: 1.21, 18: 2.43, 19: 1.75, 20: 2.05, 21: 2.54, 22: 2.96
};

const SALARY_BONUS_MAP = {
  ADMINISTRATIVE_STAFF: { salary: 'ADMIN_PERSONNEL', bonus: 'BONUS_ADMIN_PERSONNEL' },
  TEACHING_STAFF:       { salary: 'TEACHING_STAFF',  bonus: 'BONUS_TEACHING_STAFF' },
  SUPPORT_STAFF:        { salary: 'SUPPORT_STAFF',   bonus: 'BONUS_SUPPORT_STAFF' },
  SERVICE_STAFF:        { salary: 'MAINTENANCE_STAFF', bonus: 'BONUS_MAINTENANCE_STAFF' },
};

const MONTH_FIELDS = ['janSum', 'febSum', 'marSum', 'aprSum', 'maySum', 'junSum', 'julSum', 'augSum', 'sepSum', 'octSum', 'novSum', 'decSum'];

export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      expenseType: 'insurance-worker',
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        categories: [],
        months: [],
        employeeCount: 0,
        annualSalary: 0,
        annualSalaryInsurance: 0,
        calculatedInsuranceSum: 0,
        actualInsuranceSum: 0,
      },
      monthNames: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      selectedCategory: null,
      categories: {
        ADMINISTRATIVE_STAFF: "Адм.упр.персонала",
        TEACHING_STAFF: "Пед.персонал",
        SUPPORT_STAFF: "Учебно вспом-й персонал",
        SERVICE_STAFF: "Обслуживающий и прочий персонал",
      },
      salaryBonusLookup: {},
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
    };
  },
  methods: {
    async init() {
      this.isLoading = true;
      try {
        await this.findById(this.uuid);
        await this.loadSalaryBonusData();
        this.populateFromSalaryBonus();
        this.recalculateAll();
      } finally {
        this.isLoading = false;
      }
    },

    async loadSalaryBonusData() {
      try {
        const records = await expensesSalaryBonusService.getAll(this.dto.trancheYear);
        if (!records || records.length === 0) {
          this.salaryBonusLookup = {};
          return;
        }
        const record = records.find(r => r.universityId === this.dto.universityId) || records[0];
        const lookup = {};

        for (const [ogpoType, mapping] of Object.entries(SALARY_BONUS_MAP)) {
          const salaryDetail = (record.details || []).find(d => d.type === mapping.salary);
          const bonusDetail = (record.details || []).find(d => d.type === mapping.bonus);

          const factCount = salaryDetail ? parseFloat(salaryDetail.factCount || 0) : 0;
          const months = {};
          for (let m = 0; m < 12; m++) {
            const field = MONTH_FIELDS[m];
            const salaryVal = salaryDetail ? parseFloat(salaryDetail[field] || 0) : 0;
            const bonusVal = bonusDetail ? parseFloat(bonusDetail[field] || 0) : 0;
            months[m + 1] = salaryVal + bonusVal;
          }

          lookup[ogpoType] = { factCount, months };
        }

        this.salaryBonusLookup = lookup;
      } catch (e) {
        console.error('Failed to load salary-bonus data:', e);
        this.salaryBonusLookup = {};
      }
    },

    populateFromSalaryBonus() {
      if (!this.dto.categories) return;

      for (const category of this.dto.categories) {
        const sbData = this.salaryBonusLookup[category.type];
        if (!sbData) continue;

        category.employeeCount = sbData.factCount || 0;

        if (category.months) {
          for (const month of category.months) {
            month.annualSalary = sbData.months[month.month] || 0;
          }
        }
      }
    },

    onRiskClassChange(category) {
      const riskClass = category.professionalRiskClass;
      category.insuranceRatePercent = RISK_CLASS_TARIFF[riskClass] || 0;
      this.recalculateAll();
    },

    recalculateAll() {
      if (!this.dto.categories) return;

      // Category-level calculations
      for (const cat of this.dto.categories) {
        // annualSalary = sum of month annualSalary
        cat.annualSalary = (cat.months || []).reduce((sum, m) => sum + parseFloat(m.annualSalary || 0), 0);

        // calculatedInsuranceSum = annualSalaryInsurance × tariff / 100
        cat.calculatedInsuranceSum = parseFloat(cat.annualSalaryInsurance || 0) * parseFloat(cat.insuranceRatePercent || 0) / 100;

        // Month-level calculatedInsuranceSum = category value / 12
        if (cat.months) {
          for (const month of cat.months) {
            month.calculatedInsuranceSum = cat.calculatedInsuranceSum / 12;
          }
        }

        // actualInsuranceSum = sum of month values
        cat.actualInsuranceSum = (cat.months || []).reduce((sum, m) => sum + parseFloat(m.actualInsuranceSum || 0), 0);
      }

      // ВСЕГО aggregations (all computed from categories)
      this.dto.employeeCount = this.dto.categories.reduce((sum, c) => sum + parseFloat(c.employeeCount || 0), 0);
      this.dto.annualSalary = this.dto.categories.reduce((sum, c) => sum + parseFloat(c.annualSalary || 0), 0);
      this.dto.annualSalaryInsurance = this.dto.categories.reduce((sum, c) => sum + parseFloat(c.annualSalaryInsurance || 0), 0);
      this.dto.calculatedInsuranceSum = this.dto.categories.reduce((sum, c) => sum + parseFloat(c.calculatedInsuranceSum || 0), 0);
      this.dto.actualInsuranceSum = this.dto.categories.reduce((sum, c) => sum + parseFloat(c.actualInsuranceSum || 0), 0);

      // ВСЕГО month rows
      for (const month of this.dto.months) {
        month.annualSalary = this.dto.categories.reduce((sum, c) => {
          const catMonth = (c.months || []).find(m => m.month === month.month);
          return sum + (catMonth ? parseFloat(catMonth.annualSalary || 0) : 0);
        }, 0);
        // calculatedInsuranceSum for ВСЕГО months = total calculatedInsuranceSum / 12
        month.calculatedInsuranceSum = this.dto.calculatedInsuranceSum / 12;
      }
    },

    formatNum(val) {
      if (val === undefined || val === null || val === '') return '';
      const num = parseFloat(val);
      if (isNaN(num)) return '';
      if (num === 0) return '0,00';
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',');
    },

    getNotAddedCategories() {
      if (!this.dto.categories) {
        return Object.keys(this.categories);
      }
      if (this.dto.categories.length >= Object.keys(this.categories).length) {
        return [];
      }
      const addedCategories = this.dto.categories.map(c => c.type);
      return Object.keys(this.categories).filter(key => !addedCategories.includes(key));
    },

    addSelectedCategoryInfo() {
      const months = [];
      for (let i = 1; i <= 12; i++) {
        months.push({month: i, annualSalary: 0, actualInsuranceSum: null, calculatedInsuranceSum: 0});
      }

      this.dto.categories.push({
        type: this.selectedCategory,
        professionalRiskClass: null,
        insuranceRatePercent: 0,
        annualSalaryInsurance: null,
        employeeCount: 0,
        annualSalary: 0,
        calculatedInsuranceSum: 0,
        actualInsuranceSum: 0,
        months: months
      });

      this.populateFromSalaryBonus();
      this.sortByCatAndMonth();
      this.recalculateAll();
    },

    async findById(uuid) {
      this.dto = await ueExpensesCommonCrudService.findById(this.expenseType, uuid);
      this.dto.months = [];
      for (let month = 1; month <= 12; month++) {
        this.dto.months.push({month: month, annualSalary: 0, calculatedInsuranceSum: 0});
      }

      if (this.dto.categories) {
        for (const cat of this.dto.categories) {
          if (cat.professionalRiskClass) {
            cat.insuranceRatePercent = RISK_CLASS_TARIFF[cat.professionalRiskClass] || cat.insuranceRatePercent || 0;
          }
        }
      }

      this.sortByCatAndMonth();
    },

    async submitForm() {
      try {
        if (!this.hasEditPermission()) {
          return;
        }

        this.isLoading = true;
        this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
        this.dto.months = [];
        for (let month = 1; month <= 12; month++) {
          this.dto.months.push({month: month, annualSalary: 0, calculatedInsuranceSum: 0});
        }
        this.sortByCatAndMonth();
        await this.loadSalaryBonusData();
        this.populateFromSalaryBonus();
        this.recalculateAll();
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },

    sortByCatAndMonth() {
      if (!this.dto.categories) return;

      this.dto.categories.forEach(category => {
        if (category.months && category.months.length > 0) {
          category.months.sort((a, b) => a.month - b.month);
        }
      });
      this.dto.categories.sort((a, b) => {
        const order = ['ADMINISTRATIVE_STAFF', 'TEACHING_STAFF', 'SUPPORT_STAFF', 'SERVICE_STAFF'];
        return order.indexOf(a.type) - order.indexOf(b.type);
      });
    },

    goBack()  {
      this.$router.go(-1);
    },
    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED'  || !this.dto.status);
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    async onClickRemove(category) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await ueExpensesCommonCrudService.deleteCategory(this.expenseType, this.uuid, category.uuid);
          this.init();
          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

table.expenses-detail tr td {
  padding: 0 !important;
  padding-left: 5px !important;
  font-size: 14px;
}
table.expenses-detail tr td.expense-sum-edit:has(.form-control){
  padding-left: 0 !important;
}

table.expenses-detail tr td.expense-sum-edit .form-control {
  padding-left: 2px !important;
  font-size: 14px !important;
}
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.table-container { width: 100%; overflow-x: auto; }
.grid-table { width: 100%; border-collapse: collapse; min-width: 1200px; }
.grid-table th, .grid-table td { border: 1px solid #EBEEF5; padding: 8px; font-size: 13px; }
.grid-table th { background-color: #f5f7fa; text-align: center; font-weight: bold; position: sticky; top: 0; z-index: 10; }
.title-cell { width: 250px; }
.color-red, .color-red:hover {  color: red !important;}
.calculated-row { background-color: #f0f9eb; font-weight: bold; }
.readonly-text { text-align: right; padding-right: 10px !important; }
::v-deep .el-input__inner { text-align: right; font-size: 13px; -moz-appearance: textfield; }
::v-deep .el-input__inner::-webkit-outer-spin-button,
::v-deep .el-input__inner::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.total-row td {
  font-weight: bold;
}
</style>
